// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a492ffeb","499":"f49b1e25","730":"5d8f8edf"}[chunkId] + ".chunk.js";
};